<template>
  <div class="not-found">
    <div class="fixed top-0 right-0 left-0 bg-gray-500est z-40 shadow flex flex-col justify-center h-24">
      <div class="flex justify-center md:justify-between items-center brandon-regular w-full mx-auto lg:px-4 xl:max-w-screen-xl">
        <router-link to="/" class="flex items-center">
          <img src="/images/Cardstock_Logo.png" class="w-32 md:w-48">
        </router-link>
        <div class="hidden md:block">
          <a class="underline pr-4 cursor-pointer text-gray-300 hover:text-blue-700 " tabindex="0">
            See how it works</a>
          <a class="underline pr-4 cursor-pointer text-gray-300 hover:text-blue-700 " tabindex="0">
            Pricing</a>
          <router-link class="underline pr-4 cursor-pointer text-gray-300 hover:text-blue-700 " :to="{name: 'login'}" tabindex="0">
            Sign in</router-link>
          <a class="text-white py-2 px-4 rounded shadow-md cursor-pointer bg-cardstock-green-500 hover:bg-green-500 outline-none font-bold" tabindex="0">
            Sign up</a>
        </div>
      </div>
    </div>
    <div class="h-screen flex flex-col justify-center items-center">
      <div class="text-6xl mb-2">🤯</div>
      <div class="text-2xl text-center mb-2">This page doesn't exist</div>
      <div class="max-w-screen-sm mx-auto mt-8 p-4 bg-cardstock-yellow-400 rounded-lg leading-normal">
        <div class="font-bold text-xl">
          Did we send you here?
        </div>
        <div>
          If you clicked a <span class="text-cardstock-red-500">Cardstock</span> link that sent you here, we messed something up. Please <a href="mailto:lanny.bose@cardstockforteachers.com?subject=Broken%20Cardstock%20Link" class="text-cardstock-blue-500 underline">email us</a> so we can fix it.
        </div>
        <div class="mt-8 font-bold text-xl">
          Did someone else send you here?
        </div>
        <div>
          Links from other sites might be broken, and we're happy to reach out to fix the error. Please <a href="mailto:lanny.bose@cardstockforteachers.com?subject=Broken%20Cardstock%20Link" class="text-cardstock-blue-500 underline">email us</a> so we can let them know.
        </div>
        <div class="mt-8 font-bold text-xl">
          Or... well...
        </div>
        <div>
          You might've typed the address (URL) incorrectly. Check your spelling and capitalization. Or, you can just <router-link to="/" class="text-cardstock-blue-500 underline">start over</router-link>.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Container from '@/components/Container.vue'
export default {
  components: {
    Container
  }
}
</script>
